import React from 'react';

export const DownCaratIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.24651e-05 1.08709C0.000746743 1.35346 0.0963879 1.61139 0.270734 1.81707L5.43623 7.65691C5.62184 7.87414 5.89741 7.99988 6.18812 8C6.48333 7.9907 6.75893 7.85424 6.94002 7.62771L11.7521 1.78787C12.1192 1.32656 12.074 0.671862 11.6469 0.262207C11.4473 0.076305 11.1755 -0.0180496 10.8998 0.00286374C10.624 0.0237771 10.3706 0.157969 10.2032 0.371704L6.16557 5.32097L1.78204 0.349805C1.6056 0.141692 1.34576 0.0169589 1.06831 0.00718912C0.790854 -0.00258066 0.522389 0.103549 0.330885 0.298706C0.116315 0.507885 -0.00286197 0.791884 5.24651e-05 1.08709Z"
      fill="#183558"
    />
  </svg>
);
